/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UIStore from 'src/stores/alt/stores/UIStore';
import ImageAnnotationModalSVG from 'src/apps/mydb/elements/details/researchPlans/ImageAnnotationModalSVG';
import Utils from 'src/utilities/Functions';
import {
  Button, ButtonGroup, OverlayTrigger, Popover, Alert
} from 'react-bootstrap';
import AttachmentFetcher from 'src/fetchers/AttachmentFetcher';
import SaveEditedImageWarning from 'src/apps/mydb/elements/details/researchPlans/SaveEditedImageWarning';
import {
  downloadButton,
  removeButton,
  annotateButton,
  EditButton,
  importButton,
  customDropzone,
  sortingAndFilteringUI,
  formatFileSize,
  attachmentThumbnail,
  ThirdPartyAppButton,
} from 'src/apps/mydb/elements/list/AttachmentList';
import { formatDate, parseDate } from 'src/utilities/timezoneHelper';
import { StoreContext } from 'src/stores/mobx/RootStore';
import { observer } from 'mobx-react';
import UserStore from 'src/stores/alt/stores/UserStore';

const templateInfo = (
  <Popover id="popver-template-info" title="Template info">
    This template should be used to import well readouts. The&nbsp;
    <strong>red</strong>
    &nbsp;column may not be altered at all. The contents of the&nbsp;
    <strong>yellow</strong>
    &nbsp;columns may be altered, the headers may not. The&nbsp;
    <strong>green</strong>
    &nbsp;columns must contain at least one&nbsp;
    <i>_Value</i>
    &nbsp;and&nbsp;
    <i>_Unit</i>
    &nbsp;pair with a matching prefix before the underscore. They may contain an arbitrary amount of readout pairs.
  </Popover>
);

export class WellplateDetailsAttachments extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    const {
      onImport
    } = props;
    const { thirdPartyApps } = UIStore.getState() || [];
    this.thirdPartyApps = thirdPartyApps;

    this.state = {
      onImport,
      imageEditModalShown: false,
      showImportConfirm: [],
      filteredAttachments: [...props.attachments],
      filterText: '',
      sortBy: 'name',
      sortDirection: 'asc',
    };
    this.createAttachmentPreviews = this.createAttachmentPreviews.bind(this);

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.toggleSortDirection = this.toggleSortDirection.bind(this);
    this.confirmAttachmentImport = this.confirmAttachmentImport.bind(this);
    this.showImportConfirm = this.showImportConfirm.bind(this);
    this.hideImportConfirm = this.hideImportConfirm.bind(this);
  }

  componentDidMount() {
    const { attachments } = this.props;
    const updatedImportConfirm = attachments.reduce((acc, attachment) => {
      acc[attachment.id] = false;
      return acc;
    }, {});
    this.setState({ showImportConfirm: updatedImportConfirm });
    this.createAttachmentPreviews();
  }

  componentDidUpdate(prevProps) {
    const { attachments } = this.props;
    if (attachments !== prevProps.attachments) {
      this.createAttachmentPreviews();
      this.setState({ filteredAttachments: [...attachments] }, this.filterAndSortAttachments);
    }
  }

  handleTemplateDownload() { // eslint-disable-line class-methods-use-this
    const { wellplate } = this.props;
    Utils.downloadFile({
      contents: `/api/v1/wellplates/template/${wellplate.id}`,
      name: 'wellplate_import_template.xlsx'
    });
  }

  handleFilterChange = (e) => {
    this.setState({ filterText: e.target.value }, this.filterAndSortAttachments);
  };

  handleSortChange = (e) => {
    this.setState({ sortBy: e.target.value }, this.filterAndSortAttachments);
  };

  toggleSortDirection = () => {
    this.setState((prevState) => ({
      sortDirection: prevState.sortDirection === 'asc' ? 'desc' : 'asc'
    }), this.filterAndSortAttachments);
  };

  filterAndSortAttachments() {
    const { filterText, sortBy } = this.state;

    const filteredAttachments = this.props.attachments.filter(
      (attachment) => attachment.filename.toLowerCase().includes(filterText.toLowerCase())
    );

    filteredAttachments.sort((a, b) => {
      let comparison = 0;
      switch (sortBy) {
        case 'name':
          comparison = a.filename.localeCompare(b.filename);
          break;
        case 'size':
          comparison = a.filesize - b.filesize;
          break;
        case 'date': {
          const dateA = parseDate(a.created_at);
          const dateB = parseDate(b.created_at);
          comparison = dateA.valueOf() - dateB.valueOf();
          break;
        }
        default:
          break;
      }
      return this.state.sortDirection === 'asc' ? comparison : -comparison;
    });

    this.setState({ filteredAttachments });
  }

  createAttachmentPreviews() {
    const { attachments } = this.props;
    attachments.map((attachment) => {
      if (attachment.thumb) {
        AttachmentFetcher.fetchThumbnail({ id: attachment.id }).then(
          (result) => {
            if (result != null) {
              attachment.preview = `data:image/png;base64,${result}`;
              this.forceUpdate();
            }
          }
        );
      } else {
        attachment.preview = '/images/wild_card/not_available.svg';
        this.forceUpdate();
      }
      return attachment;
    });
  }

  showImportConfirm(attachmentId) {
    const { showImportConfirm } = this.state;
    showImportConfirm[attachmentId] = true;
    this.setState({ showImportConfirm });
  }

  hideImportConfirm(attachmentId) {
    const { showImportConfirm } = this.state;
    showImportConfirm[attachmentId] = false;
    this.setState({ showImportConfirm });
  }

  confirmAttachmentImport(attachment) {
    const { onImport } = this.state;
    onImport(attachment);
    this.hideImportConfirm(attachment.id);
  }

  renderImageEditModal() {
    const { chosenAttachment, imageEditModalShown } = this.state;
    const { onEdit } = this.props;
    return (
      <ImageAnnotationModalSVG
        attachment={chosenAttachment}
        isShow={imageEditModalShown}
        handleSave={
          () => {
            const newAnnotation = document.getElementById('svgEditId').contentWindow.svgEditor.svgCanvas.getSvgString();
            chosenAttachment.updatedAnnotation = newAnnotation;
            this.setState({ imageEditModalShown: false });
            onEdit(chosenAttachment);
          }
        }
        handleOnClose={() => { this.setState({ imageEditModalShown: false }); }}
      />
    );
  }

  renderTemplateDownload() {
    return (
      <div>
        <ButtonGroup className="mb-1">
          <Button
            variant="primary"
            onClick={() => this.handleTemplateDownload()}
          >
            <i className="fa fa-download" aria-hidden="true" />
            &nbsp;
            Download Import Template xlsx
          </Button>
          <OverlayTrigger placement="bottom" overlay={templateInfo}>
            <Button
              variant="info"
            >
              <i className="fa fa-info" aria-hidden="true" />
            </Button>
          </OverlayTrigger>
        </ButtonGroup>
      </div>
    );
  }

  render() {
    const {
      filteredAttachments, sortDirection
    } = this.state;
    const { onUndoDelete, attachments, wellplate } = this.props;
    const { currentUser } = UserStore.getState();

    let combinedAttachments = filteredAttachments;
    if (this.context.attachmentNotificationStore) {
      combinedAttachments = this.context.attachmentNotificationStore.getCombinedAttachments(filteredAttachments, 'Wellplate', wellplate);
    }

    return (
      <div className="attachment-main-container">
        {this.renderTemplateDownload()}
        {this.renderImageEditModal()}
        <div className="d-flex justify-content-between align-items-center">
          <div className="flex-grow-1 align-self-center">
            {customDropzone(this.props.onDrop)}
          </div>
          <div className="ms-3 align-self-center">
            {
              attachments.length > 0
              && sortingAndFilteringUI(
                sortDirection,
                this.handleSortChange,
                this.toggleSortDirection,
                this.handleFilterChange,
                true
              )
            }
          </div>
        </div>
        {combinedAttachments.length === 0 ? (
          <div className="no-attachments-text">
            There are currently no attachments.
          </div>
        ) : (
          <>
            {combinedAttachments.map((attachment) => (
              <div className="attachment-row" key={attachment.id}>
                {attachmentThumbnail(attachment)}

                <div className="attachment-row-text" title={attachment.filename}>
                  {attachment.is_deleted ? (
                    <strike>{attachment.filename}</strike>
                  ) : (
                    attachment.filename
                  )}
                  <div className="attachment-row-subtext">
                    <div>
                      Created:&nbsp;
                      {formatDate(attachment.created_at)}
                    </div>
                    <span className="mx-2">|</span>
                    <div>
                      Size:&nbsp;
                      <strong>
                        {formatFileSize(attachment.filesize)}
                      </strong>
                    </div>
                  </div>
                </div>
                <div className="attachment-row-actions d-flex align-items-center gap-1">
                  {attachment.is_deleted ? (
                    <Button
                      size="sm"
                      variant="danger"
                      className="attachment-button-size"
                      onClick={() => onUndoDelete(attachment)}
                    >
                      <i className="fa fa-undo" aria-hidden="true" />
                    </Button>
                  ) : (
                    <>
                      {downloadButton(attachment)}
                      <ThirdPartyAppButton attachment={attachment} options={this.thirdPartyApps} />
                      <EditButton attachment={attachment} onChange={this.props.onEdit} />
                      {annotateButton(attachment, () => {
                        this.setState({
                          imageEditModalShown: true,
                          chosenAttachment: attachment,
                        });
                      })}
                      {importButton(
                        attachment,
                        this.state.showImportConfirm,
                        this.props.wellplate.changed,
                        this.showImportConfirm,
                        this.hideImportConfirm,
                        this.confirmAttachmentImport
                      )}
                      &nbsp;
                      {removeButton(attachment, this.props.onDelete, this.props.readOnly)}
                    </>
                  )}
                </div>
                {attachment.updatedAnnotation && <SaveEditedImageWarning visible />}
              </div>
            ))}
            <Alert variant="warning" show={UserStore.isUserQuotaExceeded(filteredAttachments)}>
              Uploading attachments will fail; User quota
              {currentUser !== null ? ` (${currentUser.allocated_space / 1024 / 1024} MB) ` : ' '}
              will be exceeded.
            </Alert>
          </>
        )}
      </div>
    );
  }
}

WellplateDetailsAttachments.propTypes = {
  wellplate: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    changed: PropTypes.bool,
    attachments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ]).isRequired,
        aasm_state: PropTypes.string.isRequired,
        content_type: PropTypes.string.isRequired,
        filename: PropTypes.string.isRequired,
        filesize: PropTypes.number.isRequired,
        identifier: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ]).isRequired,
        thumb: PropTypes.bool.isRequired
      })
    )
  }).isRequired,
  attachments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    aasm_state: PropTypes.string.isRequired,
    content_type: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    filesize: PropTypes.number.isRequired,
    identifier: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    thumb: PropTypes.bool.isRequired
  })),
  onDrop: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUndoDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onImport: PropTypes.func.isRequired,
};

WellplateDetailsAttachments.defaultProps = {
  attachments: [],
};

export default observer(WellplateDetailsAttachments);
